import { useEffect } from "react";

export default function DownloadStoreRedirectPage() {
    const handleGoToStoreClick = () => {
        const params = new URLSearchParams(window.location.search);
        const eventId = params.get("eventId"); // get eventId from the URL

        const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;

        const iosUrl = `https://apps.apple.com/de/app/baila/id6462697936${eventId ? `?eventId=${eventId}` : ""}`;
        const androidUrl = `https://play.google.com/store/apps/details?id=com.baila_client${eventId ? `&eventId=${eventId}` : ""}`;

        if (/android/i.test(userAgent)) {
            window.location.href = androidUrl;
        } else if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
            window.location.href = iosUrl;
        } else {
            window.location.href = iosUrl;
        }
    };

    useEffect(() => {
        handleGoToStoreClick();
    }, []);

    return (
        <div className="flex items-center justify-center h-screen">
            <div className="flex flex-col items-center gap-3">
                <p className="text-lg">Redirecting you to the right app store...</p>
                <button
                    type="button"
                    onClick={handleGoToStoreClick}
                    className="rounded-full bg-white px-6 py-3 text-black hover:bg-neutral-100"
                >
                    Zum Appstore
                </button>
            </div>
        </div>
    );
}
